import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "data-link-name"];
const _hoisted_2 = { class: "sidebar-item-label" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'sidebar-menu-section-item',
    props: {
        label: {},
        url: {},
        iconName: {},
        analytics: {},
        isSelected: { type: Boolean },
        isExpanded: { type: Boolean },
        items: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(["sidebar-menu-section-item", { 'is-selected': _ctx.isSelected }]),
                href: _ctx.url,
                "data-link-name": _ctx.analytics
            }, [
                _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
                ])
            ], 10, _hoisted_1));
        };
    }
});
